export default function FieldErrorMessage(props: { message?: string }) {
  return <div className="text-danger fs-smaller-1">{props.message}</div>;
}
